// import React, { useState, useEffect } from 'react'
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { NavLink, useParams } from 'react-router-dom';

// import image from '../Components/img/logo.png';
// import Picture from "../Components/img/pic.png";
// import user_service from "../Components/service/user_service"
// import jwt from "jwt-decode";

// const [banners, setBanners] = useState("");

// const bannerGetAll = async () => {
//   await user_service.bannerGetAll().then((response) => {
//       if (response) {
//           // console.log(response);
//           setBanners(response.data);
//       }
//   });
// };
// useEffect(() => { window.scrollTo(0, 0);

//     bannerGetAll();
// }, []);

const people = [
    {
      id: 1,
      url_link:"",
      marque_image:
        'https://cdn.pboffice.net/org/cache/image.ashx?/NORTHSTAR/Banner/Marquee/ceb3a74d-1825-4691-83a3-ff3278ee2798.jpg'
          },
    {
      id: 2,
      url_link:"",
      marque_image:
        'https://cdn.pboffice.net/org/cache/image.ashx?/NORTHSTAR/Banner/Marquee/d0e09ff6-0b2e-4b14-b04c-04ebdca744d2.jpg'
        },
    {
      id: 3,
      url_link:"",
      marque_image:
        'https://cdn.pboffice.net/org/cache/image.ashx?/NORTHSTAR/Banner/Marquee/e35ff7e5-b83d-46da-9af1-b641dfec657a.jpg',
         },
    {
      id: 4,
      url_link:"",
      marque_image:
        'https://cdn.pboffice.net/org/cache/image.ashx?/NORTHSTAR/Banner/Marquee/28173c2b-a2a2-4ba1-910a-a2f7a66cd35a.jpg',
        },
    {
      id: 5,
      url_link:"",
      marque_image:
        'https://cdn.pboffice.net/org/cache/image.ashx?/NORTHSTAR/Banner/Marquee/a54ca18a-3590-402e-9e1e-9e3a7914e03a.jpg',
        },
  ];
  
  export default people;
  